import React from "react";
import {Route} from "react-router-dom";
import BulkDelete from "./containers/BulkDelete/";
import Activation from "./containers/Activation/";

export default [
  <Route exact path="/bulkdelete" component={BulkDelete} />,
  <Route exact path="/activation" component={Activation} />
];



// WEBPACK FOOTER //
// ./src/customRoutes.js